import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'

export interface CatalogRemoteImage {
    id: number
    title: string
    isDownloaded: number
}

export interface CatalogRemoteListResponse {
    success: number
    errorMsg?: string
    images: CatalogRemoteImage[]
}

export interface CatalogLocalImage {
    id: number
    title: string
    name: string
    width: number
    height: number
    bpp: number
    format: string
    byteOrder: string
}

export interface CatalogLocalListResponse {
    success: number
    errorMsg?: string
    images: CatalogLocalImage[]
}

export interface CatalogStorageInfoResponse {
    success: number
    totalBytes: number
    usedBytes: number
    freeBytes: number
    errorMsg?: string
}

export interface CatalogActionResponse {
    imageId: number
    success: number
    errorMsg?: string
}

export async function getCatalogRemoteList(clientId: string, includeDownloaded = 0): Promise<ApiResponse<CatalogRemoteListResponse>> {
    const response = await fetch(`${HOST_URL}catalog/remote-list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, includeDownloaded }),
    })
    const result = (await response.json()) as ApiResponse<CatalogRemoteListResponse>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getCatalogLocalList(clientId: string): Promise<ApiResponse<CatalogLocalListResponse>> {
    const response = await fetch(`${HOST_URL}catalog/local-list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<CatalogLocalListResponse>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getCatalogStorageInfo(clientId: string): Promise<ApiResponse<CatalogStorageInfoResponse>> {
    const response = await fetch(`${HOST_URL}catalog/storage-info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<CatalogStorageInfoResponse>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function downloadCatalogImage(clientId: string, imageId: number, title?: string): Promise<ApiResponse<CatalogActionResponse>> {
    const response = await fetch(`${HOST_URL}catalog/download`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, imageId, title }),
    })
    const result = (await response.json()) as ApiResponse<CatalogActionResponse>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function deleteCatalogImage(clientId: string, imageId: number): Promise<ApiResponse<CatalogActionResponse>> {
    const response = await fetch(`${HOST_URL}catalog/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, imageId }),
    })
    const result = (await response.json()) as ApiResponse<CatalogActionResponse>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
